<template lang="pug">
.breadcrumbs.font-medium.flex.gap-1.items-center(data-qa="step0-profile-header")
  .item.title-sm.text-center {{ $t('ORDER_PROFILES') }}
  svg(xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" @click="$emit('closeClick')", data-qa="step0-profile-header-close")
    path(fill-rule="evenodd" clip-rule="evenodd" d="M6.29289 16.2929C5.90237 16.6834 5.90237 17.3166 6.29289 17.7071C6.68342 18.0976 7.31658 18.0976 7.70711 17.7071L12 13.4142L16.2929 17.7071C16.6834 18.0977 17.3166 18.0977 17.7071 17.7071C18.0977 17.3166 18.0977 16.6834 17.7071 16.2929L13.4142 12L17.7071 7.70709C18.0977 7.31657 18.0977 6.6834 17.7071 6.29288C17.3166 5.90235 16.6834 5.90235 16.2929 6.29288L12 10.5858L7.70711 6.2929C7.31658 5.90237 6.68342 5.90237 6.29289 6.2929C5.90237 6.68342 5.90237 7.31659 6.29289 7.70711L10.5858 12L6.29289 16.2929Z" fill="#6C7885")
</template>

<script>
export default {
  name: 'ProfileHeader',
}
</script>

<style lang="scss">
.breadcrumbs {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-bottom: 1px solid #e5ecf1;

  svg {
    cursor: pointer;
  }

  .without-icon {
    opacity: 0;
    cursor: default;
  }
}
</style>
